import React from 'react';
import PropTypes from 'prop-types';

import './WorldDetail.scss';
import {Link} from "react-router-dom";

const WorldDetail = (props) => {
    const {display, updateStatus, disableStatus, id, name, code, skey, purpose, is_active, is_complete, hideGoto} = props;
    return (
        <div className={`${display || !is_complete ? "active" : "hidden"}`}>

            <div className={`flex flex-justify-between flex-datas-end game__container`}>

                <div className={`container gameDetails__container`}>

                    <div className="container flex flex-datas-center flex-50-50">
                        <div className={`gameName container`}>
                            {name}
                        </div>
                        <div className={`joinGame container`}>
                            {!hideGoto &&
                                <Link to={`/instructor/world/${skey}`}>Go to dashboard</Link>
                            }
                        </div>
                    </div>


                    <div className="container flex flex-datas-center flex-50-50">
                        <div className="container">
                            <div className="flex flex-40-60">
                                <span className="container">Code:</span>
                                <span
                                    className="container">
                                    <strong>{code}</strong>
                                </span>
                            </div>
                        </div>
                        <div className="container"/>
                    </div>

                    <div className="container flex flex-datas-center flex-50-50">
                        <div className="container">
                            <div className="flex flex-40-60">
                                <span className="container">Purpose:</span>
                                <span
                                    className="container">
                                    <strong>{purpose}</strong>
                                </span>
                            </div>
                        </div>
                        <div className="container"/>
                    </div>

                </div>

                {
                    is_complete ?
                        <div className="container">
                            <h4>Completed</h4>
                        </div>
                        :
                        <div className="container">
                            <input
                                className={`tgl tglSkewed`}
                                id={`cb3-${id}`}
                                type="checkbox"
                                onClick={e => updateStatus(e, id)}
                                checked={is_active}
                                readOnly
                            />
                            <label
                                className={`tglBtn ${disableStatus && 'tglDisabled'}`}
                                data-tg-off="Inactive"
                                data-tg-on="Active"
                                htmlFor={`cb3-${id}`}
                            />

                        </div>
                }

            </div>
        </div>
    );
};

WorldDetail.propTypes = {
    display: PropTypes.bool.isRequired,
    updateStatus: PropTypes.func.isRequired,

    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    skey: PropTypes.string.isRequired,
    purpose: PropTypes.string.isRequired,
    is_active: PropTypes.bool.isRequired,
    is_complete: PropTypes.bool.isRequired,

    disableStatus: PropTypes.bool,
    hideGoto: PropTypes.bool,
}
;

export default WorldDetail;
